import Vue from 'vue'

let initialState = {
  view: "normal",
  ws_channels: {},
  logged_in: false,
  account: undefined,
  groups: [],
  sessions: [],
  profile_presence: {},
  channels: {},
  channels_uuid: {},
  channelList: [],

  channel_templates: {},
  channel_template_list: [],

  channel_access_groups: {},
  channel_access_group_list: [],

  devices: {},
  deviceList: [],

  all_groups: {},
  groups_uuid: {},
  groupList: [],
  instances: {},
  instanceList: [],
  instance_status: {},
  devices: {},
  deviceList: [],
  channel_status: {},
  mediaconnects_status: {},
  settings: {},
  settingList: [],
  filters: {},
  filterList: [],
  cms_list_types: {},
  cms_list_types_list: [],

  cms_lists: {},
  cms_lists_list: [],

  accounts: {},
  accountList: [],
  cache: {},
  running_orders: {},
  runningOrderList: [],
  timestamp: 0,
  maintenance: {
    running: false,
    info: {}
  }
}

export const state = Vue.util.extend({}, initialState)

export const mutations = {
  logged_in (state, value) {
    state.logged_in = value;
  },
  set_view (state, view) {
    window.sessionStorage.setItem('kepit-view', view);
    state.view = view;
  },
  set_profile (state, profile) {
    state.account = profile.account;
    state.sessions = profile.sessions;
  },
  set_profile_presence (state, presence) {
    state.profile_presence = presence;
  },
  set_websocket_channel ({ ws_channels }, channel) {
    Vue.set(ws_channels, channel.name, channel.channel);
  },
  set_channels ({ channels, channels_uuid, channelList }, list) {
    if(Object.keys(channels).length) channels = {};
    if(Object.keys(channels_uuid).length) channels_uuid = {};
    if(channelList.length) channelList = [];
    list.forEach((channel) => {
      Vue.set(channels, channel.id, channel);
      Vue.set(channels_uuid, channel.uuid, channel);
      channelList.push(channel.id)
    });
  },
  update_channel({ channels, channels_uuid, channelList }, channel) {
    Vue.set(channels, channel.id, channel);
    Vue.set(channels_uuid, channel.uuid, channel)
    if(channelList.indexOf(channel.id) == -1) channelList.push(channel.id);
  },
  delete_channel({ channels, channels_uuid, channelList }, channel) {
    if(typeof(channels[channel.id]) != "undefined") Vue.delete(channels, channel.id);
    if(typeof(channels_uuid[channel.uuid]) != "undefined") Vue.delete(channels_uuid, channel.uuid);
    let index = channelList.indexOf(channel.id);
    if(index != -1) channelList.splice(index, 1);
  },

  set_channel_templates ({ channel_templates, channel_template_list}, list) {
    if(Object.keys(channel_templates).lenght) channel_templates = {};
    if(channel_template_list.length) channel_template_list = [];
    list.forEach((channel_template) => {
      Vue.set(channel_templates, channel_template.id, channel_template);
      channel_template_list.push(channel_template.id);
    });
  },
  update_channel_template({ channel_templates, channel_template_list}, channel_template) {
    Vue.set(channel_templates, channel_template.id, channel_template);
    if(channel_template_list.indexOf(channel_template.id) == -1) channel_template_list.push(channel_template.id);
  },
  delete_channel_template({ channel_templates, channel_template_list }, channel_template) {
    if(typeof(channel_templates[channel_template.id]) != "undefined") Vue.delete(channel_templates, channel_template.id);
    let index = channel_template_list.indexOf(channel_template.id);
    if(index != -1) channel_template_list.splice(index, 1);
  },

  set_channel_access_groups ({ channel_access_groups, channel_access_group_list}, list) {
    if(Object.keys(channel_access_groups).lenght) channel_access_groups = {};
    if(channel_access_group_list.length) channel_access_group_list = [];
    list.forEach((channel_access_group) => {
      Vue.set(channel_access_groups, channel_access_group.id, channel_access_group);
      channel_access_group_list.push(channel_access_group.id);
    });
  },
  update_channel_access_group({ channel_access_groups, channel_access_group_list}, channel_access_group) {
    Vue.set(channel_access_groups, channel_access_group.id, channel_access_group);
    if(channel_access_group_list.indexOf(channel_access_group.id) == -1) channel_access_group_list.push(channel_access_group.id);
  },
  delete_channel_access_group({ channel_access_groups, channel_access_group_list }, channel_access_group) {
    if(typeof(channel_access_groups[channel_access_group.id]) != "undefined") Vue.delete(channel_access_groups, channel_access_group.id);
    let index = channel_access_group_list.indexOf(channel_access_group.id);
    if(index != -1) channel_access_group_list.splice(index, 1);
  },

  set_groups ({ all_groups, groups_uuid, groupList }, list) {
    if(Object.keys(all_groups).length) all_groups = {};
    if(Object.keys(groups_uuid).length) groups_uuid = {};
    if(groupList.length) groupList = [];
    list.forEach((group) => {
      Vue.set(all_groups, group.id, group);
      Vue.set(groups_uuid, group.uuid, group);
      groupList.push(group.id)
    });
  },
  update_group({ all_groups, groups_uuid, groupList }, group) {
    Vue.set(all_groups, group.id, group);
    Vue.set(groups_uuid, group.uuid, group)
    if(groupList.indexOf(group.id) == -1) groupList.push(group.id);
  },
  delete_group({ all_groups, groups_uuid, groupList }, group) {
    if(typeof(all_groups[group.id]) != "undefined") Vue.delete(all_groups, group.id);
    if(typeof(groups_uuid[group.uuid]) != "undefined") Vue.delete(groups_uuid, group.uuid);
    let index = groupList.indexOf(group.id);
    if(index != -1) groupList.splice(index, 1);
  },
  set_instances ({ instances, instanceList}, list) {
    if(Object.keys(instances).lenght) instances = {};
    if(instanceList.length) instanceList = [];
    list.forEach((instance) => {
      Vue.set(instances, instance.id, instance);
      instanceList.push(instance.id);
    });
  },
  update_instance({ instances, instanceList}, instance) {
    Vue.set(instances, instance.id, instance);
    if(instanceList.indexOf(instance.id) == -1) instanceList.push(instance.id);
  },
  delete_instance({ instances, instanceList }, instance) {
    if(typeof(instances[instance.id]) != "undefined") Vue.delete(instances, instance.id);
    let index = instanceList.indexOf(instance.id);
    if(index != -1) instanceList.splice(index, 1);
  },
  set_devices ({ devices, deviceList}, list) {
    if(Object.keys(devices).lenght) devices = {};
    if(deviceList.length) deviceList = [];
    list.forEach((device) => {
      Vue.set(devices, device.id, device);
      deviceList.push(device.id);
    });
  },
  update_device({ devices, deviceList}, device) {
    Vue.set(devices, device.id, device);
    if(deviceList.indexOf(device.id) == -1) deviceList.push(device.id);
  },
  delete_device({ devices, deviceList }, device) {
    if(typeof(devices[device.id]) != "undefined") Vue.delete(devices, device.id);
    let index = deviceList.indexOf(device.id);
    if(index != -1) deviceList.splice(index, 1);
  },
  set_settings ({ settings, settingList}, list) {
    if(Object.keys(settings).lenght) settings = {};
    if(settingList.length) settingList = [];
    list.forEach((setting) => {
      Vue.set(settings, setting.id, setting);
      settingList.push(setting.id);
    });
  },
  update_setting({ settings, settingList}, setting) {
    Vue.set(settings, setting.id, setting);
    if(settingList.indexOf(setting.id) == -1) settingList.push(setting.id);
  },
  delete_setting({ settings, settingList }, setting) {
    if(typeof(settings[setting.id]) != "undefined") Vue.delete(settings, setting.id);
    let index = settingList.indexOf(setting.id);
    if(index != -1) settingList.splice(index, 1);
  },
  set_filters ({ filters, filterList}, list) {
    if(Object.keys(filters).lenght) filters = {};
    if(filterList.length) filterList = [];
    list.forEach((filter) => {
      Vue.set(filters, filter.id, filter);
      filterList.push(filter.id);
    });
  },
  update_filter({ filters, filterList}, setting) {
    Vue.set(filters, filter.id, filter);
    if(filterList.indexOf(filter.id) == -1) filterList.push(filter.id);
  },
  delete_filter({ filters, filterList }, filter) {
    if(typeof(filters[filter.id]) != "undefined") Vue.delete(filters, filter.id);
    let index = filterList.indexOf(filter.id);
    if(index != -1) filterList.splice(index, 1);
  },
  set_instance_status(state, status) {
    state.instance_status = status;
  },
  set_channel_status(state, status) {
    state.channel_status = status;
  },
  set_mediaconnects_status(state, status) {
    state.mediaconnects_status = status;
  },
  set_timestamp(state, timestamp) {
    state.timestamp = timestamp;
  },

  set_cms_list_types({cms_list_types, cms_list_types_list}, list_types) {
    if (Object.keys(cms_list_types).length) cms_list_types = {};
    if (cms_list_types_list.length) cms_list_types_list = [];
    list_types.forEach((list_type) => {
      Vue.set(cms_list_types, list_type.id, list_type);
      cms_list_types_list.push(list_type.id);
    });
  },
  update_cms_list_type({cms_list_types, cms_list_types_list}, list_type) {
    Vue.set(cms_list_types, list_type.id, list_type);
    if(cms_list_types_list.indexOf(list_type.id) == -1) cms_list_types_list.push(list_type.id);
  },
  delete_cms_list_type({cms_list_types, cms_list_types_list}, list_type) {
    if(typeof(cms_list_types[list_type.id]) != "undefined") Vue.delete(cms_list_types, list_type.id);
    let index = cms_list_types_list.indexOf(list_type.id);
    if(index != -1) cms_list_types_list.splice(index, 1);
  },

  set_cms_lists({cms_lists, cms_lists_list}, lists) {
    if (Object.keys(cms_lists).length) cms_lists = {};
    if (cms_lists_list.length) cms_lists_list = [];
    lists.forEach((list) => {
      Vue.set(cms_lists, list.id, list);
      cms_lists_list.push(list.id);
    });
  },
  update_cms_list({cms_lists, cms_lists_list}, list) {
    Vue.set(cms_lists, list.id, list);
    if(cms_lists_list.indexOf(list.id) == -1) cms_lists_list.push(list.id);
  },
  delete_cms_list({cms_lists, cms_lists_list}, list) {
    if(typeof(cms_lists[list.id]) != "undefined") Vue.delete(cms_lists, list.id);
    let index = cms_lists_list.indexOf(list.id);
    if(index != -1) cms_lists_list.splice(index, 1);
  },
  set_accounts ({ accounts, accountList}, list) {
    if(Object.keys(accounts).lenght) accounts = {};
    if(accountList.length) accountList = [];
    list.forEach((account) => {
      Vue.set(accounts, account.id, account);
      accountList.push(account.id);
    });
  },
  update_account({ accounts, accountList}, account) {
    Vue.set(accounts, account.id, account);
    if(accountList.indexOf(account.id) == -1) accountList.push(account.id);
  },
  delete_account({ accounts, accountList }, instance) {
    if(typeof(accounts[account.id]) != "undefined") Vue.delete(accounts, account.id);
    let index = accountList.indexOf(account.id);
    if(index != -1) accountList.splice(index, 1);
  },
 set_running_orders ({ running_orders, runningOrderList}, list) {
    if(Object.keys(running_orders).lenght) instances = {};
    if(runningOrderList.length) runningOrderList = [];
    list.forEach((running_order) => {
      Vue.set(running_orders, running_order.id, running_order);
      runningOrderList.push(running_order.id);
    });
  },
  update_running_order({ running_orders, runningOrderList}, running_order) {
    Vue.set(running_orders, running_order.id, running_order);
    if(runningOrderList.indexOf(running_order.id) == -1) runningOrderList.push(running_order.id);
  },
  delete_running_order({ running_orders, runningOrderList }, running_order) {
    if(typeof(running_orders[running_order.id]) != "undefined") Vue.delete(running_orders, running_order.id);
    let index = runningOrderList.indexOf(running_order.id);
    if(index != -1) runningOrderList.splice(index, 1);
  },
  clear (state, events) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  }
}
